import { Button, ButtonsGroup, Heading, PageHeader } from "@/components/atoms";
import { ContentSelected, InProgress, WorkDone } from "./States";
import { FC, memo, useMemo } from "react";
import { NATURAL } from "@/theme";
import { ORDER_STATE } from "@/types";
import { ORDER_STEP } from "../Order/Order/Order.interface";
import { OrderCreate } from "../Order/Order-Create";
import { OrderCustomerProps } from "./OrderCustomer.interface";
import { useNavigate } from "react-router-dom";

const OrderCustomer: FC<OrderCustomerProps> = ({ 
    isAdmin,
    extraText,
    offeredServices,
    onAddNote,
    onChangePackage,
    orderDetails,
    ...props
    } ) => {

    

  const navigate = useNavigate();

  const getBanner = useMemo(() => {
    switch (orderDetails.orderTemplateId) {
      case 10468:
        return '/photoediting_banner.jpg';
      case 10469:
        return '/floorplan_banner.jpg';
      case 10470:
        return '/virtualstaging_banner.jpg';
      default:
        return '/neworder_banner.png';
    }
  }, [orderDetails]);

  const selectedOrder = useMemo(() => {
    return {
      activeStep: ORDER_STEP.BOOKING,
      customerId: orderDetails.customerId,
      description: orderDetails.description,
      id: Number(orderDetails.id),
      imageUrl: '',
      isAdmin: isAdmin,
      isVirtual: false,
      orderTypeId: 0,
      price: orderDetails.orderPrice,
      services: [],
    };
  }, [orderDetails, isAdmin, offeredServices]);

  const handleViewOuttakes = async () => {
    navigate('/order-view-outtakes/order=' + orderDetails.id);
  }
 
  const getStatusComponent = () => {
    switch (orderDetails.orderState) {
      case ORDER_STATE.AWAITING_DATE:
      case ORDER_STATE.BOOKING_IN_PROGRESS:
      case ORDER_STATE.BOOKING_PLACED:
      case ORDER_STATE.RETURN_TO_WORK:
      default:
        return (<InProgress isAdmin={isAdmin} orderDetails={orderDetails} offeredServices={offeredServices} onChangePackage={onChangePackage} onAddNote={onAddNote}  {...props} />);
      case ORDER_STATE.COMPLETE:
        return (<WorkDone isAdmin={isAdmin} orderDetails={orderDetails} offeredServices={offeredServices} onChangePackage={onChangePackage} onAddNote={onAddNote} {...props} />);
      case ORDER_STATE.CONTENT_SELECTED:
      case ORDER_STATE.ORDER_PAID:
      case ORDER_STATE.AWAITING_CARD_PAYMENT:
        return (<ContentSelected isAdmin={isAdmin} orderDetails={orderDetails} offeredServices={offeredServices} onChangePackage={onChangePackage} onAddNote={onAddNote} {...props} />);
        
    }
  }

  return (
    <OrderCreate
            activeStep={ORDER_STEP.BOOKING}
            extraText={extraText}
            isAdmin={isAdmin}
            isReadOnly={true}
            selectedOrder={selectedOrder}
            onCreateOrder={() => true }
          >
            <>
            <div>
              <a title="Check out Photoclear.ai" href="https://app.photoclear.ai" target="_blank" rel="noreferrer">
                <img src={getBanner} alt="Order Customer View" style={{width: '100%'}} />
              </a>
            </div>
            <PageHeader>
              <Heading scale="h1" fontColor={NATURAL.K}>{orderDetails.description}</Heading>
              <ButtonsGroup maxWidth="500px" flexWrap="wrap" >
                { orderDetails.orderState < ORDER_STATE.COMPLETE && <Button actionType='outline' onClick={onChangePackage}>Change Package</Button> }
                <Button onClick={handleViewOuttakes}>View Outtakes</Button>
                { isAdmin && <>
                <Button onClick={props.onNavigateToAdmin}>Admin View</Button>
                <Button onClick={props.onNavigateToWorker}>Worker View</Button>
              </> }
              </ButtonsGroup>
            </PageHeader>
              { getStatusComponent() }
            </>
        </OrderCreate>
  );
}

export default memo(OrderCustomer);